import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import { Dialog } from 'primereact/dialog'
import { LuxButton, LuxRadioInput } from '@lux/wardrobe-lib'
import './DialogSpiltFile.scss'
import { UploadFileType } from '@/app/services/ProjectsService'

const DialogSpiltFile = (props: {
    dialogVisible: boolean
    onSave: (splitValue) => void
    onHide: () => void
}) => {
    const { dialogVisible, onSave, onHide } = props

    const [splitValue, setSplitValue] = useState(UploadFileType.FILE.toString())

    const componentClass = 'smart-modals-dialog-split-file'

    const intl = useIntl()

    const renderFooter = () => {
        return (
            <div className={`${componentClass}-buttons`}>
                <LuxButton
                    onClick={() => onSave(splitValue)}
                    text={intl.formatMessage({
                        id: 'modals.dialog.redo_dialog.button.confirm',
                        defaultMessage: 'Confirm',
                    })}
                />
            </div>
        )
    }

    return (
        <Dialog
            header={intl.formatMessage({
                id: 'modals.dialog.split.file',
                defaultMessage: 'Split file',
            })}
            draggable={false}
            visible={dialogVisible}
            onHide={() => onHide()}
            footer={renderFooter()}
            style={{ width: '50vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '85vw' }}>
            <div className={`${componentClass}-description`}>
                <LuxRadioInput
                    value={splitValue}
                    name="splitFile"
                    onChangeCallback={setSplitValue}
                    radioList={[
                        {
                            value: 'split_by_row',
                            label: intl.formatMessage({
                                id: 'modals.dialog.split.file.row',
                                defaultMessage: 'Split row',
                            }),
                        },
                    ]}
                />
                <LuxRadioInput
                    value={splitValue}
                    name="splitFile"
                    onChangeCallback={setSplitValue}
                    radioList={[
                        {
                            value: 'split_by_sheet',
                            label: intl.formatMessage({
                                id: 'modals.dialog.split.file.sheet',
                                defaultMessage: 'Split sheet',
                            }),
                        },
                    ]}
                />
                <LuxRadioInput
                    value={splitValue}
                    name="splitFile"
                    onChangeCallback={setSplitValue}
                    radioList={[
                        {
                            value: UploadFileType.FILE,
                            label: intl.formatMessage({
                                id: 'modals.dialog.split.file.none',
                                defaultMessage: 'None',
                            }),
                        },
                    ]}
                />
            </div>
        </Dialog>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(DialogSpiltFile)
